import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]

import * as echarts from "echarts";
import {EChartsType} from "echarts/core";
import {onMounted,watch} from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'twoBarInOne',
  props: {
  className: {
    type: String,
    default: 'chart'
  },
  id: {
    type: String,
    default: 'chart'
  },
  width: {
    type: String,
    default: '200px'
  },
  height: {
    type: String,
    default: '200px'
  },
  xdata1:{
    type:Array,
    default:()=>[]
  },
  xdata2:{
    type:Array,
    default:()=>[]
  },
  chartData:{
    type:Array,
    default:()=>[]
  },
},
  setup(__props) {

let props = __props

let chart:EChartsType;
const initChart =()=> {
  // 基于准备好的dom，初始化echarts实例
  let myChart = echarts.init(document.getElementById(props.id))
  // 绘制图表
  myChart.setOption({
    legend: {
      data: ['已完成', '未完成'],
      right:'10'
    },
    tooltip:{
      show:true,
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      }
    },
    xAxis: {
      type: 'value',
      axisLine:{
        show:true,
        lineStyle:{
          color:'#939FBD',
        }
      },
      axisLabel:{
        interval:0,
        width:50,
        overflow:'truncate',
        ellipsis:'...'
      },
    },
    yAxis: {
      type: 'category',
      axisLine:{
        show:true,
        lineStyle:{
          color:'#939FBD',
        }
      },
      axisLabel:{
        interval:0,
        width:40,
        overflow:'truncate',
        ellipsis:'...'
      },
      data:props.chartData,
    },
    grid: {
      bottom: 20,
      right:10,
      left:50,
      top:30,
    },
    series: [
      {
        name: '已完成',
        type: 'bar',
        stack: 'total',
        data: props.xdata1,
        color:'#BCE2FF',
        barWidth:30,
      },
      {
        name: '未完成',
        type: 'bar',
        stack: 'total',
        data: props.xdata2,
        color:'#7DE3FF',
        barWidth:30,
      },
    ]
  });
  return myChart
}
watch(
  ()=>props.chartData,
  (newList,oldList)=>{
    let chart = initChart()
    chart&&chart.resize()
  },
  {deep:true}
)
onMounted(()=>{
  let chart = initChart()
  window.addEventListener('resize',function (){
    chart&&chart.resize()
  })

})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: __props.id,
    class: _normalizeClass(__props.className),
    style: _normalizeStyle({height:__props.height,width:__props.width})
  }, null, 14, _hoisted_1))
}
}

})